package devxertech.com.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.BoxSizing
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxSizing
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.disabled
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onBlur
import com.varabyte.kobweb.compose.ui.modifiers.onFocus
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.resize
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import devxertech.com.style.LoginInputStyleDefault
import devxertech.com.theme.LocalColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.TextArea


@Composable
fun ResizableTextAreaField(
    value: String = "",
    onValueChange: (String) -> Unit = {},
    placeholder: String = "",
    width: CSSLengthOrPercentageNumericValue = 100.percent,
    height: CSSLengthNumericValue = 100.px,
    minHeight: CSSLengthNumericValue = 20.px,
    maxHeight: CSSLengthNumericValue = 200.px,
    id: String = "",
    fontSize: CSSLengthNumericValue? = null,
    leftPadding: CSSLengthNumericValue = 15.px,
    topPadding: CSSLengthNumericValue = 15.px,
    bottomPadding: CSSLengthNumericValue = 15.px,
    rightPadding: CSSLengthNumericValue = 15.px,
    marginBottom: CSSLengthNumericValue = 0.px,
    marginLeft: CSSLengthNumericValue = 0.px,
    marginRight: CSSLengthNumericValue = 0.px,
    disabled: Boolean = false,
    disableButKeepStyle: Boolean = false,
    resize: Boolean = true,
    maxCharLimit: Int? = null,
) {
    val colorMode = LocalColorMode.current
    val sitePalette = colorMode.toSitePalette()
    var isFocused by remember { mutableStateOf(false) }
    val currentModifier = if (disabled && !disableButKeepStyle) {
        LoginInputStyleDefault.border(width = 0.px)
    } else {
        LoginInputStyleDefault
    }
    val limitedValue = maxCharLimit?.let { value.take(it) } ?: value

    var text by remember(value) { mutableStateOf(value.take(maxCharLimit ?: Int.MAX_VALUE)) }

    Column(modifier = Modifier.width(width)) {
        Box(
            modifier = Modifier
                .width(width)
                .position(Position.Relative)
                .border(0.px)
                .borderRadius(8.px)
                .backgroundColor(sitePalette.contactLeft.rgb)
                .border(
                    1.px,
                    LineStyle.Solid,
                    if (isFocused)
                        sitePalette.primary.rgb             // focus color
                    else
                        sitePalette.contactLeft.rgb  // normal
                ),
        ) {
            TextArea(
                attrs = currentModifier
                    .id(id)
                    .width(100.percent)
                    .height(height)
                    .minHeight(minHeight)
                    .maxHeight(maxHeight)
                    .border(0.px)
                    .borderRadius(8.px)
                    .fontSize(15.px).fontWeight(FontWeight.Medium)
                    .fontFamily(Constants.FONT_FAMILY)
                    .resize(if (resize) Resize.Vertical else Resize.None)
                    .padding(
                        left = leftPadding,
                        right = rightPadding,
                        top = topPadding,
                        bottom = bottomPadding
                    )
                    .margin(bottom = marginBottom, left = marginLeft, right = marginRight)
                    .backgroundColor(sitePalette.contactLeft.rgb)
                    .color(
                        if (disabled && !disableButKeepStyle)
                            sitePalette.textFieldSupportiveTextColor.rgb
                        else sitePalette.textFieldTextColor.rgb
                    )
                    .boxSizing(BoxSizing.BorderBox)
                    .outline(0.px, LineStyle.None, Colors.Transparent)
                    .disabled(disabled)
                    .onFocus { isFocused = true }
                    .onBlur { isFocused = false }
                    .toAttrs {
                        attr("placeholder", placeholder)

                        value(text)

                        onInput {
                            val newText = it.value.take(maxCharLimit ?: Int.MAX_VALUE)
                            text = newText
                            onValueChange(newText)
                        }
                    }
            )
        }

    }
}